<template lang="pug">
div(v-if="reflection")
  output.no-margin-if-last-in-bundle(:class="{ open }")
    button(v-if="tooltip", @click="open = !open", :class="{ open }") ?
    span {{ reflection }}
  TransitionExpand
    aside(v-if="tooltip && open")
      small.no-margin-if-last-in-bundle {{ tooltip }}
</template>

<script>
import TransitionExpand from "../../transitions/ExpandGroup.vue";
import { mapGetters } from "vuex";

export default {
  name: "Reflection",
  components: {
    TransitionExpand,
  },
  props: {
    field: Object,
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters(["model"]),
    tooltip() {
      return this.field.tooltip || false;
    },
    reflection() {
      let value = this.model[this.field.reflect] || false;

      if (value && Array.isArray(value)) value = value.join(" ");
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  display: contents;
}
aside {
  display: flex;
  small {
    padding: 0.75rem;
    font-style: italic;
    border: 1px solid $slate;
    position: relative;
    margin: 0.5rem 0 1.75rem;
    &::after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 1.125rem;
      height: 0;
      width: 0;
      border-bottom: 0.35rem solid $slate;
      border-left: 0.25rem solid transparent;
      border-right: 0.25rem solid transparent;
    }
  }
}
output {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0.5rem 0.75rem;
  line-height: 1;
  border: 1px solid;
  align-self: flex-start;
  gap: 0.5rem;
  transition: margin-bottom 350ms ease;
  &:not(.open),
  &:only-child {
    margin: 0 0 1.75rem;
  }
  .field-title + & {
    margin-top: -1.125rem;
  }
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    appearance: none;
    color: $midnight;
    border: 1px solid $midnight;
    border-radius: 50%;
    padding: 0;
    margin: 0;
    background: none;
    height: 1.125rem;
    width: 1.125rem;
    font-size: 0.875rem;
    cursor: pointer;
    transition: 0.2s ease;
    &.open,
    &:hover {
      background: $navy;
      color: $white;
    }
  }
}
</style>
